var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcController(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4981 11.7308C19.7588 8.61177 18.6623 6.62214 16.9049 6.13729C16.5645 6.04463 16.2116 5.9984 15.857 6.00005C14.7766 6.00005 13.924 6.60001 11.9999 6.60001C10.0757 6.60001 9.22148 6.00005 8.14267 6.00005C7.77332 5.99827 7.40551 6.04446 7.0498 6.13729C5.28996 6.62214 4.20272 8.61364 3.45499 11.7308C2.69159 14.9148 2.8298 17.4305 4.32205 17.9135C5.3667 18.2509 6.30087 17.5531 7.18561 16.526C8.19008 15.3561 9.42719 14.9961 11.9999 14.9961C14.5725 14.9961 15.7614 15.3561 16.7675 16.526C17.6514 17.5539 18.6202 18.2431 19.6371 17.9195C21.2852 17.3941 21.2619 14.9523 20.4981 11.7308Z",
    stroke: "#8890A6",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11C13.7761 11 14 10.7761 14 10.5C14 10.2239 13.7761 10 13.5 10C13.2239 10 13 10.2239 13 10.5C13 10.7761 13.2239 11 13.5 11Z",
    fill: "#8890A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13C15.4011 13 15.3043 12.9706 15.2221 12.9156C15.1398 12.8607 15.0757 12.7825 15.0379 12.6911C15.0001 12.5996 14.9903 12.499 15.0097 12.402C15.0291 12.305 15.0768 12.2159 15.1469 12.146C15.2169 12.0761 15.3061 12.0286 15.4032 12.0095C15.5003 11.9903 15.6009 12.0004 15.6922 12.0384C15.7835 12.0765 15.8616 12.1407 15.9163 12.2231C15.9711 12.3055 16.0002 12.4023 16 12.5012C15.9997 12.6336 15.9468 12.7605 15.8531 12.854C15.7594 12.9475 15.6324 13 15.5 13Z",
    fill: "#8890A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10C15.7761 10 16 9.55228 16 9C16 8.44772 15.7761 8 15.5 8C15.2239 8 15 8.44772 15 9C15 9.55228 15.2239 10 15.5 10Z",
    fill: "#8890A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11C17.7761 11 18 10.7761 18 10.5C18 10.2239 17.7761 10 17.5 10C17.2239 10 17 10.2239 17 10.5C17 10.7761 17.2239 11 17.5 11Z",
    fill: "#8890A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9V12M9 10.5H7",
    stroke: "#8890A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcController);
export default __webpack_public_path__ + "static/media/ic_controller.f47a208ad8a6e78bc56d53b7339b49cd.svg";
export { ForwardRef as ReactComponent };